import React from 'react';
import { CaretDownIcon, CaretUpIcon } from '../../SVGIcons/SVGIcons';

export default function SellerContact(props) {
	const { order, textboxesOpen, openTextbox } = props || {};
	return (
		<>
			<div className='rightSidebarTextContainer'>
				<div className='sidebarTextHeader' onClick={() => openTextbox('contact')}>
					<h4 className='bold'>Seller's contact</h4>
					{textboxesOpen['contact'] ? (
						<CaretUpIcon iconClass={'caretUpIcon'} />
					) : (
						<CaretDownIcon iconClass={'caretDownIcon'} />
					)}
				</div>
				{order && textboxesOpen['contact'] && <></>}
			</div>
		</>
	);
}
